<template>
  <section>
    <div class="dropdown--relative">
      <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none p-0 d-flex align-items-center button--dropdown" no-caret class="dropdown--container" :class="isModal ? 'dropdown--container--modal' : ''" @shown="showDropdown = true" @hidden="showDropdown = false">
        <template #button-content>
          <b-icon class="drop--icon-select" :style="{color: computedCardColor}" icon="circle-fill"></b-icon>
          <b-icon class="drop--icon" :icon="showDropdown ? 'chevron-up' : 'chevron-down'"></b-icon>
        </template>
        <b-dropdown-item v-for="(color, index) in colorOptions" :key="index" link-class="dropdown-link-class" @click="selectColor(color)">
          <div class="link--container">
            <b-icon :style="{color: color.colorIcon}" icon="circle-fill"></b-icon>
            <p class="p-0 options--dropdown-text m-0">{{color.text}}</p>
          </div>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </section>
</template>
<script>
import BaseServices from '@/store/services/index'
import { BIcon, BIconCircleFill, BIconChevronDown, BIconChevronUp } from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
export default {
  props: ['colorId', 'colorArray', 'ticketId', 'isModal'],
  components: { BIcon, BIconCircleFill, BIconChevronUp, BIconChevronDown },
  data() {
    return {
      baseService: new BaseServices(this),
      showDropdown: false,
      changeColorId: null
    }
  },
  computed: {
    cardColor() {
      const color = this.colorOptions.find(el => el.colorId === this.colorId)
      return color ? color.colorIcon : '#B0BEC5'
    },
    cardColorChange() {
      const color = this.colorOptions.find(el => el.colorId === this.changeColorId)
      return color ? color.colorIcon : ''
    },
    computedCardColor() {
      return this.cardColorChange || this.cardColor
    },
    colorOptions() {
      return this.colorArray || []
    }
  },
  methods: {
    selectColor(color) {
      const sendData = {
        ticket_id: parseInt(this.ticketId),
        color_tag_id: parseInt(color.colorId)
      }
      this.baseService.callService('postColorsTicket', sendData)
        .then(response => {
          if (response.data) this.changeColorId = response.data.color_tag_id
        })
        .catch(err => {
          this.$error('Ha ocurrido un error')
          console.error(err)
        })
    }
  }
}
</script>
<style lang="scss">
  .dropdown--relative {
    position: relative;

    .dropdown--container {
      position: absolute;
      right: 10px;
      top: 10px;
      .drop--icon-select, .drop--icon {
        width: 16px;
        height: 16px;
      }
      .drop--icon {
        margin-left: 5px;
      }
    }
    .dropdown--container--modal {
      position: static;
    }
    .options--dropdown-text {
      font-family: Montserrat;
      font-size: 12px;
      font-weight: 300;
      color: #5C5C5C;
    }
    .dropdown-link-class {
      padding: 10px;
    }
    .link--container {
      display: flex;
      gap: 10px;
      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
</style>